import {Component} from '@angular/core';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionScheduleItemInPathGroup} from '@domain/production-schedule/production-schedule-item-in-path-group';
import {GridOrderLineStatusComponent} from '@presentation/components/order-lines-grid/grid-order-line-status/grid-order-line-status.component';
import {TagColor} from '@vdw/angular-component-library';
import {ProductionScheduleOrderLineWithQuantity} from '../production-schedule-order-line-with-quantity';
import {OrderLineStatusCellRendererParams} from './order-line-status-cell-renderer-params.interface';

@Component({
  templateUrl: './order-line-status-cell-renderer.component.html',
  styleUrls: ['./order-line-status-cell-renderer.component.scss']
})
export class OrderLineStatusCellRendererComponent extends GridOrderLineStatusComponent {
  private readonly inScheduleTranslationKey = 'IN_SCHEDULE';
  private productionScheduleOrderLineWithQuantity: ProductionScheduleOrderLineWithQuantity;
  private productionSchedule: ProductionSchedule;

  public agInit(params: OrderLineStatusCellRendererParams): void {
    super.agInit(params);

    this.productionScheduleOrderLineWithQuantity = params.data instanceof ProductionScheduleItemInPathGroup ? params.data.orderline : params.data;
    this.productionSchedule = params.productionSchedule;
    this.statusLabel = this.getQuantityInProductionSchedule() > 0 ? this.inScheduleTranslationKey : this.statusLabel;
  }

  public getColor(): TagColor {
    if (this.getQuantityInProductionSchedule() === 0) {
      return super.getColor();
    }

    const inProductionSchedule = this.productionScheduleOrderLineWithQuantity?.article?.design?.repeated
      ? this.productionScheduleOrderLineWithQuantity?.getHeightLeftInMMForProductionSchedule(this.productionSchedule.getProductionScheduleItemMultiplier())
      : this.productionScheduleOrderLineWithQuantity?.getAmountLeftForProductionSchedule(this.productionSchedule.getProductionScheduleItemMultiplier());

    return inProductionSchedule <= 0 ? TagColor.SUCCESS : TagColor.WARNING;
  }

  private getQuantityInProductionSchedule(): number {
    return this.productionScheduleOrderLineWithQuantity?.article?.design?.repeated
      ? this.productionScheduleOrderLineWithQuantity?.heightInProductionScheduleInMM
      : this.productionScheduleOrderLineWithQuantity?.amountInProductionSchedule;
  }
}
